
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"94","height":"79","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.456 16.617a2.19 2.19 0 002.188-2.188V2.188a2.189 2.189 0 00-4.375 0V14.43c0 1.21.98 2.187 2.187 2.187zm-18.059 3.375a2.186 2.186 0 003.094 0 2.186 2.186 0 000-3.094l-8.656-8.656a2.186 2.186 0 00-3.094 0 2.186 2.186 0 000 3.094l8.656 8.656zM9.8 33.488h12.24a2.189 2.189 0 000-4.375H9.8a2.189 2.189 0 000 4.375zm53.316-12.855c.559 0 1.121-.215 1.547-.64l8.656-8.657a2.186 2.186 0 000-3.094 2.186 2.186 0 00-3.094 0L61.57 16.9a2.186 2.186 0 001.547 3.734zm5.711 10.668a2.19 2.19 0 002.188 2.188H83.26a2.189 2.189 0 000-4.375H71.015c-1.207 0-2.188.98-2.188 2.187zM93.12 76.09l-4.625-15.418a2.186 2.186 0 00-2.094-1.559h-8.554L73.69 45.254a2.186 2.186 0 00-2.094-1.558h-8.555l-4.156-13.86a2.186 2.186 0 00-2.094-1.558l-20.37.004c-.966 0-1.817.633-2.095 1.559L30.171 43.7h-8.555c-.965 0-1.816.633-2.093 1.558l-4.157 13.86-8.554-.005c-.965 0-1.817.633-2.094 1.559L.093 76.09a2.189 2.189 0 002.094 2.816h88.84a2.186 2.186 0 002.094-2.816zM73.276 59.113h-23.73L52.86 48.07h17.109l3.308 11.043zM61.41 69.105l-1.683-5.617h3.37l-1.687 5.617zM46.604 53.687l-1.683-5.617h3.37l-1.687 5.617zm-8.554-21.03h17.109l3.312 11.042H34.737l3.313-11.043zM23.245 48.073h17.109l3.312 11.043-7.246-.004H19.932l3.313-11.039zm8.55 21.031l-1.683-5.617h3.37l-1.687 5.617zM5.123 74.531l3.313-11.043h17.109l3.312 11.043H5.123zm29.613 0l3.313-11.043h17.109l3.312 11.043H34.736zm29.613 0l3.313-11.043H84.77l3.312 11.043H64.35z"}})])
          )
        }
      }
    